import { useQuery } from "@apollo/client";

import { LIST_OWN_OEM_ROLES_QUERY } from "~/api";
import type { RoleData } from "~/services/roles/types";

/** The OEM's roles: Admin, Supervisor and Technician first, then custom ones. */
export const useListOwnOemRoles = ({ skip = false } = {}) => {
  const { data, loading, error, refetch } = useQuery<{
    listOwnOemRoles: RoleData[];
  }>(LIST_OWN_OEM_ROLES_QUERY, { skip, fetchPolicy: "cache-and-network" });

  return { roles: data?.listOwnOemRoles ?? [], loading, error, refetch };
};
